// @flow

import React, { type Node } from 'react';
import Barcode from 'react-barcode';

import { formatBoletoNumber } from '@tectonics/prs/boleto';
import { getSafeBoletoBarcode, getBoletoBarcodeRaw, usePendingIncomingPayment } from '@tectonics/prs/incoming-payment';
import { IfFeature } from '@tectonics/prs/feature';
import { useAllFeatures } from '@tectonics/prs/payment-spec';

import { CopyToClipboardButton } from '../../../../commons/molecules';
import { Separator } from '../../../../commons/atoms';
import { VoucherNumberWrapper, VoucherNumber } from '../commons/voucher/number';
import { VoucherBarcodeWrapper } from '../commons/voucher/barcode';

export function BoletoBarcode(): Node {
  const allFeatures = useAllFeatures();

  const incomingPayment = usePendingIncomingPayment();
  const boletoBarcode = getSafeBoletoBarcode(incomingPayment);
  const segments = formatBoletoNumber(boletoBarcode).split(' ');

  return (
    <section>
      <Separator pattern="dotted" />
      <IfFeature allFeatures={allFeatures} wanted="display_boleto_barcode">
        <VoucherBarcodeWrapper>
          <Barcode format="ITF" value={getBoletoBarcodeRaw(incomingPayment)} displayValue={false} />
        </VoucherBarcodeWrapper>
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="display_boleto_number">
        <VoucherNumberWrapper>
          {segments.map((segment, index) => (
            <VoucherNumber outline compact key={index}>
              {segment}
            </VoucherNumber>
          ))}
        </VoucherNumberWrapper>
      </IfFeature>

      <IfFeature allFeatures={allFeatures} wanted="action_boleto_copy_code">
        <Separator size="1em" />
        <CopyToClipboardButton
          copyMessage="Copiar código"
          copiedMessage="Copiado!"
          value={getSafeBoletoBarcode(incomingPayment)}
        />
      </IfFeature>
      <Separator size="1em" />
      <Separator pattern="dotted" />
    </section>
  );
}
